import React from "react";
import "assets/scss/website/app.scss";
import classnames from "classnames";
import "react-rangeslider/lib/index.css";
import "../styles.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const TableList = (props) => {
	const { appointment } = props;
	const AuthData = useSelector((state) => state.Auth);
	const { t } = useTranslation();
	const currency = useSelector((state) => state.Auth?.currency);
	return (
		<>
			<tr>
				<td>
					<p className="text-muted mb-0 resale-2line">{appointment?.title}</p>
				</td>
				{/* <td
					className={classnames("", {
						"text-end": AuthData.lang === "ar",
						"text-start": AuthData.lang !== "ar",
					})}>
					<p className="mb-1 resale-line">{appointment?.sales_rep?.name}</p>
				</td> */}
				<td
					className={classnames("", {
						"text-end": AuthData.lang === "ar",
						"text-start": AuthData.lang !== "ar",
					})}>
					<p className="mb-0 resale-line">
						{!!appointment?.resale?.id
							? appointment?.resale?.name[`${AuthData.lang || "en"}`]
							: appointment?.unit?.name[`${AuthData.lang || "en"}`]}
					</p>
				</td>
				<td>
					<p className="text-muted mb-0 resale-2line">{appointment?.type}</p>
				</td>
				<td>
					<p className="text-muted mb-0 resale-2line">{appointment?.date}</p>
				</td>
				<td
					className={classnames("", {
						"text-end": AuthData.lang === "ar",
						"text-start": AuthData.lang !== "ar",
					})}>
					{t(appointment?.status)}
				</td>
			</tr>
		</>
	);
};

export default TableList;
